import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { updateOpenSideMenu } from 'src/store/common-slices/sideNavSlice';
import SideNav from './SideNav';

const mapStateToProps = (state: RootState) => ({
    openSideMenu: state.SideNav.openSideMenu,
    accessibleTools: state.Init.initData.associateDetails.accessibleTools,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    updateOpenSideMenu: (openSideMenu: boolean) => dispatch(updateOpenSideMenu(openSideMenu)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);
